import { useState } from 'react';
import { useAuth } from '@/store/auth';
import { ApiError } from '@/lib/api';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : '登入失敗');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--bg)',
      }}
    >
      <form
        onSubmit={submit}
        className="card"
        style={{ padding: 32, width: 360, boxShadow: 'var(--shadow-lg)' }}
      >
        <h1 style={{ color: 'var(--primary)', margin: '0 0 4px', fontSize: 22 }}>
          漂亮 CRM
        </h1>
        <p style={{ color: 'var(--ink-3)', margin: '0 0 24px' }}>
          醫美一站式多租戶 SaaS
        </p>
        <label style={labelStyle}>Email</label>
        <input
          style={inputStyle}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
          placeholder="you@clinic.tw"
        />
        <label style={labelStyle}>密碼</label>
        <input
          style={inputStyle}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          placeholder="請輸入密碼"
        />
        {error && (
          <div style={{ color: 'var(--danger)', fontSize: 12, marginBottom: 12 }}>
            {error}
          </div>
        )}
        <button
          className="btn btn-primary"
          style={{ width: '100%' }}
          disabled={busy || !email.trim() || !password}
        >
          {busy ? '登入中…' : '登入'}
        </button>
      </form>
    </div>
  );
}

const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: 12,
  color: 'var(--ink-3)',
  marginBottom: 4,
};

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px 10px',
  border: '1px solid var(--line)',
  borderRadius: 'var(--r-md)',
  marginBottom: 16,
  fontSize: 13,
};
